import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {PenggunaAplikasiWithMenuModel} from '../../_model/pengguna-info.model';
import {AuthenticationService} from '../../_services/auth/authentication.service';
import {PenggunaInfoService} from '../../_services/pengguna-info.service';
import {NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  // currentLogin : any;
  button: Object;
  userRole: any;
  listAplikasi: any = [];
  showMe = false;
  public isCollapsed: boolean = false;
  

  // loginStatus$ : Observable<boolean>;

  listAplikasiWithMenu: Array<PenggunaAplikasiWithMenuModel> = [];

  constructor(
    private _auth: AuthenticationService,
    private _router: Router,
    private _penggunaInfoService: PenggunaInfoService,
    private _ngbCollapseModule: NgbCollapseModule
  ) {
  }

  ngOnInit() {
    if (this._auth.isAuthenticated()) {
      this.showMe = true;
      this.getOtoritas();
      this.button = 'Log Out';
    } else {
      this.button = 'Login';
    }


    // this.currentLogin = this._auth.currentUser
    // this.loginStatus$ = this._auth.isLogin
    // console.log(`login status ${this.loginStatus$}`);

  }
  toggleNav() {
    this.isCollapsed = !this.isCollapsed;
  }

  getOtoritas() {
    this._penggunaInfoService.listOtoritas().subscribe((response) => {
      if (response.status === 200) {
        this._penggunaInfoService.listAplikasiWithMenu().subscribe(response2 => {
            if (response2.status === 200) {
              this.listAplikasi = response2.body;
              var user = JSON.parse(localStorage.getItem("currentUser"));

              for (let i = 0; i < this.listAplikasi.length; i++) {
                if (this.listAplikasi[i].kode == 'BOP') {
                  for (let j = 0; j < this.listAplikasi[i].menu.length; j++) {
                    if (this.listAplikasi[i].menu[j].link == 'persetujuan-npd' && user.authorities[0] == 'SUDIN') {
                      this.listAplikasi[i].menu[j].link = 'persetujuan-npd-sudin-bop';
                    }
                  }
                }
              }
            }
          }, error => {
          }
        );
      }
    }
  );
  }

  // getAplikasi(){
  //   this._penggunaService.listAplikasi().subscribe(
  //     resp=>{
  //       console.log(resp)
  //     }, error =>{
  //       console.log(error)
  //     }
  //   )
  // }

  getButton() {
  console.log("tes");
  }


  click() {
    if (this._auth.isAuthenticated()) {
      localStorage.removeItem('currentUser');
      location.reload();
      window.localStorage.clear();
    } else {
      this._router.navigate(['/login']);
    }
  }

}
